export default __webpack_public_path__ + "static/media/mobscore_address_template.9c13f910.csv";